// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.cash-request-form[data-v-57478ac3] {\n    margin: 2em 0;\n}\n", ""]);
// Exports
module.exports = exports;
